import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { BsModalService } from 'ngx-bootstrap/modal';
import { of } from 'rxjs/internal/observable/of';
import { catchError, map, switchMap } from 'rxjs/operators';
import { BsModalAlertComponent, createAlertModalOptions } from '../core/modal/modal-alert.component';
import { JobActions } from './job.actions';
import { JobService } from './job.service';

@Injectable()
export class JobEffects {
    constructor(
        private actions$: Actions,
        private jobService: JobService,
        private modalService: BsModalService) {
    }

    sendTestMessage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(JobActions.sendTestMessage),
            switchMap((action: any) =>
                this.jobService
                    .sendAR3Test(action.context, action.userId, action.userName, action.contentType, action.templateFileRef,
                        action.templateId, action.destinator, action.mediaType, action.deviceId)
                    .pipe(
                        map((response: any) =>
                                JobActions.sendTestMessageSuccess()
                        ),
                        catchError(error =>
                            of(JobActions.sendTestMessageFailed({error}))
                        )
                    )
            )
        )
    );

    sendTestMessageSuccess$ = createEffect(() =>
            this.actions$
                .pipe(
                    ofType(JobActions.sendTestMessageSuccess),
                    map((action: any) => {
                        this.modalService
                            .show(BsModalAlertComponent,
                                createAlertModalOptions('Alert', 'Test Message Sent Successfully!!!'));
                    })),
        { dispatch: false }
    );

    sendTestMessageFail$ = createEffect(() =>
            this.actions$
                .pipe(
                    ofType(JobActions.sendTestMessageFailed),
                    map((action: any) => {
                        this.modalService
                            .show(BsModalAlertComponent,
                                createAlertModalOptions('Server Error', action.error.error.error.reason));
                    })),
        { dispatch: false }
    );

}
